const getters = {
  result: state => {
    return state.result
  },
  resultCount: state => {
    return state.resultCount
  },
  pageCount: state => {
    return state.pageCount
  },
  currPage: state => {
    return state.currPage
  },
  query: state => {
    return state.query
  },
  noResult: state => {
    return state.noResult
  },
  appliedFilters: state => {
    return state.appliedFilters
  },
  favorites: state => {
    return state.favorites
  },
  favoriteCandidates: state => {
    return state.favoriteCandidates
  },
  recJobCodes: state => {
    return state.recJobCodes
  },
  subscriptionDetail: state => {
    return state.subscriptionDetail
  },
}

export default getters
